import React, { useEffect, useState } from "react";
import { CrudModal } from "../../components/_index";
import { getHrAdminWorkHistory } from "../../services/hrAndAdminWork.service";
import moment from "moment";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box
} from "@mui/material";

const HrAndAdminWorkHistory = ({ open, handleClose, workId }) => {
    const [history, setHistory] = useState([]);

    useEffect(() => {
        if (workId && open) {
            getHistory();
        }
    }, [workId, open]);

    const getHistory = async () => {
        try {
            const res = await getHrAdminWorkHistory(workId);
            if (res && res.data) {
                setHistory(res.data);
            }
        } catch (error) {
            console.log("Error fetching history:", error);
        }
    };

    return (
        <CrudModal
            open={open}
            handleClose={handleClose}
            title="Work History"
            maxWidth="md"
        >
            <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
                <TableContainer component={Paper} elevation={0} variant="outlined">
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                <TableCell><strong>Date</strong></TableCell>
                                <TableCell><strong>Action</strong></TableCell>
                                <TableCell><strong>Performed By</strong></TableCell>
                                <TableCell><strong>Details</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {history.length > 0 ? (
                                history.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{moment(row.date).format("DD-MM-YYYY HH:mm")}</TableCell>
                                        <TableCell>{row.action}</TableCell>
                                        <TableCell>{row.performedByName || "-"}</TableCell>
                                        <TableCell>{row.details || "-"}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={4} align="center">
                                        No history found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </CrudModal>
    );
};

export default HrAndAdminWorkHistory;
